export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/amazon-store-badge-white.9bb9c036.svg","height":48,"width":129};